import { ToastMessageId } from '@core';

export const OFFLINE_MESSAGE_ID: ToastMessageId = 'online-offline-message';
